import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormTitle from '../../../library/form/components/FormTitle';
import FormButton from '../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiAction, UiTitle, UiViewContent} from "../../../library/layout/Index";
import FormLauncher from '../docAutomation/FormLauncher';

//row.rowKey 
const DocAttachment = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)
    else
        return (
            <div >
                <UiView>
                    <UiViewHeading>
                        <UiTitle>
                            <FormTitle formObject={formObject} value="Attachment" />
                        </UiTitle>
                        <UiAction>
                            <FormButton formObject={formObject} headerKey="header" starIcon={'adds'} className="uiActionIconButton"
                                        action={{ actionId: "new", paramName:"viewIsActive",  actionParam: {}, containerKey: "popup" }}
                                        text={<SarasTrans value="Attachment" />}></FormButton>
                        </UiAction>
                    </UiViewHeading>
                    <UiViewContent>
                        <div className=" uiSecContents">
                            <ul>
                                {
                                    Object.values(viewData).map((row, index) => (
                                        <FormLauncher viewMap={formObject.viewMap} formObject={formObject} 
                                        pushFormObject={1}
                                        compositionKey={row.rowKey} viewData={row} rowKey={row.rowKey} ></FormLauncher>     
                                    ))
                                }
                            </ul>
                        </div>
                    </UiViewContent>
                </UiView>
            </div>
        )
}

export default withView(DocAttachment, "docAttachment", "docAttachment,taskComp");